<template>
  <div class="dailyBox">
    <div class="itemBox">
      <statisticsNavLeft
        @tab-data="tabDataMe"
        @leftCom-data="leftComDataMe"
        @headerTab-flag="headerFalgMe"
      ></statisticsNavLeft>
    </div>
    <div class="itemBox">
      <!-- <weekCom @select-ids="weekIds"></weekCom> -->
    </div>
    <div class="itemBox">
      <div class="header">
        <div class="heaItem"></div>
        <div class="heaItem">
          <a-input-search
            v-model="searchValue"
            @search="onSearch"
            style="width:200px;margin-right:10px"
            placeholder="请输入学生名字"
            enter-button
          />
          <a-button @click="btnExport">导出</a-button>
        </div>
      </div>
      <div class="content">
        <a-table
          size="middle"
          :rowKey="record => record.studentNo"
          :loading="tableLoading"
          :dataSource="pageData"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: selectChange
          }"
          :pagination="false"
        >
          <a-table-column
            :title="$t('public.studentId')"
            dataIndex="studentNo"
          ></a-table-column>

          <a-table-column :title="$t('public.name')" dataIndex="name">
          </a-table-column>

          <a-table-column
            :title="$t('public.englishName')"
            dataIndex="englishName"
          >
          </a-table-column>
          <a-table-column
            :title="$t('public.averageScore')"
            dataIndex="averageScore"
            :sorter="averageScoreSort"
          >
          </a-table-column>
          <a-table-column title="GPA" dataIndex="gpa" :sorter="gpaSort">
          </a-table-column>
        </a-table>
      </div>
    </div>
    <a-modal
      title="导出数据"
      :visible="exportVisible"
      :confirm-loading="confirmLoading"
      @ok="exportHandleOk"
      @cancel="
        () => {
          exportVisible = false
        }
      "
    >
      <p>确定导出当前数据</p>
    </a-modal>
  </div>
</template>

<script>
import qs from 'qs'
import config from '../../config/index.js'
import statisticsNavLeft from './statisticsNavLeftCom'
// import weekCom from './weekCom'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      exportVisible: false,
      confirmLoading: false,
      pageData: [],
      tableLoading: false,
      selectedRowKeys: [],
      total: 0,
      current: 0,
      pageSize: 25,
      headerFalg: undefined,
      weekIdsData: [],
      selectTabData: [],
      clickedCoureData: {},
      searchValue: undefined
    }
  },
  components: {
    statisticsNavLeft
    // weekCom
  },
  watch: {},
  computed: {
    ...mapGetters(['currentAcademicYear', 'currentSemerter', 'userId'])
  },
  //  this.$http(this.$api.getAllCourseList, data).then(r => {
  //     this.teachersData = r.data.rows
  //     let pagination = this.pagination
  //     pagination.total = parseInt(r.data.total)
  //     this.pagination = pagination
  //   })
  methods: {
    averageScoreSort(a, b) {
      return a.averageScore < b.averageScore
    },
    gpaSort(a, b) {
      return a.gpa < b.gpa
    },
    onSearch() {
      this.getTableData()
    },
    headerFalgMe(val) {
      this.headerFalg = val
    },
    //选择栏的数据
    tabDataMe(data) {
      this.selectTabData = data
      this.getTableData()
    },
    leftComDataMe(data) {
      this.clickedCoureData = data
      this.getTableData()
    },
    weekIds(data) {
      this.weekIdsData = data
      this.getTableData()
    },
    getTableData() {
      //headerFlag == 1代表tab栏上班级的item,headerFlag == 2代表tab的年级
      let clickedCoureData = this.clickedCoureData
      let data
      if (this.headerFalg == 1) {
        data = {
          name: this.searchValue,
          classId: clickedCoureData.parentId,
          courseId: JSON.stringify(clickedCoureData.clickedData),
          weekId: JSON.stringify(this.weekIdsData),
          academic: this.currentAcademicYear,
          term: this.currentSemerter
        }
      } else if (this.headerFalg == 2) {
        data = {
          name: this.searchValue,
          grade: clickedCoureData.parentId,
          courseId: JSON.stringify(clickedCoureData.clickedData),
          weekId: JSON.stringify(this.weekIdsData),
          academic: this.currentAcademicYear,
          term: this.currentSemerter
        }
      }

      this.$http(this.$api.comprehensiverTableData, data).then(r => {
        this.pageData = r.data
      })
    },
    btnExport() {
      this.exportVisible = true
    },
    downloadFileByBlob(fileBlob) {
      let fileName = `数据统计.xls`
      const link = document.createElement('a')

      link.style.display = 'none'
      link.href = URL.createObjectURL(fileBlob)
      // link.download = res.headers['content-disposition'] //下载后文件名
      link.download = fileName //下载的文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.visibleExpotant = false
      this.$message.success('导出成功')
      this.confirmLoading = false
      this.exportVisible = false
      this.selectedRowKeys = []
    },
    exportHandleOk() {
      this.confirmLoading = true
      let selectTabData = this.selectTabData
      let clickedCoureData = this.clickedCoureData
      let data
      if (this.headerFalg == 1) {
        data = {
          classId: clickedCoureData.parentId,
          courseId: JSON.stringify(clickedCoureData.clickedData),
          weekId: JSON.stringify(this.weekIdsData),
          academic: selectTabData.academic,
          term: selectTabData.semester
        }
      } else if (this.headerFalg == 2) {
        data = {
          grade: clickedCoureData.parentId,
          courseId: JSON.stringify(clickedCoureData.clickedData),
          weekId: JSON.stringify(this.weekIdsData),
          academic: selectTabData.academic,
          term: selectTabData.semester
        }
      }
      this.$axios({
        method: 'POST',
        url: config.baseURL + this.$api.exportComprehensiver,
        data: qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        responseType: 'blob'
      }).then(r => {
        this.downloadFileByBlob(r.data)
      })
    },
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    currentChange() {},
    showSizeChange() {},
    sorterName() {}
  }
}
</script>
<style lang="less" scoped>
.dailyBox {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex; /* Safari */
  .itemBox:nth-child(1) {
    width: 200px;
  }
  // .itemBox:nth-child(2) {
  //   width: 200px;
  // }
  .itemBox:nth-child(3) {
    width: calc(100% - 200px);
    .header {
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      display: -webkit-flex; /* Safari */
      width: 100%;
      .heaItem:first-child {
        font-size: 16px;
      }
      .heaItem {
        width: 100px;
        line-height: 40px;
        // float: left;
      }
      .heaItem:last-child {
        width: calc(100% - 80px);
        display: flex;
        display: -webkit-flex; /* Safari */
        justify-content: flex-end;
        // float: left;
      }
    }
    .content {
      padding: 10px;
      box-sizing: border-box;
      width: 100%;
    }
  }
}
</style>
